import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _typeof from "@babel/runtime/helpers/typeof";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { GeonexAPIError } from 'flow/components/error-handling/GeonexAPIError';
import { regionCheckEndpoint } from './app-utils';
import { regions, sourceData } from 'flow/constants/region-lookup/login-data';
var ALLOWED_HOST_PATTERNS = [/^https:\/\/[a-z0-9-]+\.telavox\.com$/, /^https:\/\/[a-z0-9-]+\.joinflow\.com$/, /^https:\/\/[a-z0-9-]+\.joinflow\.co\.uk$/, /^https:\/\/[a-z0-9-]+\.telavox\.se$/];
var VALID_REGIONS = new Set(Object.values(regions));
var VALID_SOCIAL_LOGIN_TYPES = new Set(Object.values(sourceData));
export var isAllowedUrl = function isAllowedUrl(url) {
  return ALLOWED_HOST_PATTERNS.some(function (pattern) {
    return pattern.test(url);
  });
};
var isValidSocialLoginType = function isValidSocialLoginType(value) {
  return typeof value === 'string' && VALID_SOCIAL_LOGIN_TYPES.has(value);
};
export var validateRegionData = function validateRegionData(data) {
  if (!data || _typeof(data) !== 'object') return null;
  var _ref = data,
    url = _ref.url,
    region = _ref.region,
    userName = _ref.userName,
    lastUpdatedTime = _ref.lastUpdatedTime,
    successLoginCompleted = _ref.successLoginCompleted,
    isOidcLogin = _ref.isOidcLogin,
    socialLoginType = _ref.socialLoginType,
    socialSelectedUrl = _ref.socialSelectedUrl,
    displayName = _ref.displayName;
  if (typeof url !== 'string' || !isAllowedUrl(url)) return null;
  if (typeof region !== 'string' || !VALID_REGIONS.has(region)) return null;
  return {
    url: url,
    region: region,
    userName: typeof userName === 'string' ? userName : undefined,
    lastUpdatedTime: typeof lastUpdatedTime === 'number' ? lastUpdatedTime : null,
    successLoginCompleted: !!successLoginCompleted,
    isOidcLogin: !!isOidcLogin,
    socialLoginType: isValidSocialLoginType(socialLoginType) ? socialLoginType : undefined,
    socialSelectedUrl: typeof socialSelectedUrl === 'string' && isAllowedUrl(socialSelectedUrl) ? socialSelectedUrl : undefined,
    displayName: typeof displayName === 'string' ? displayName : undefined
  };
};
var UNSAFE_PATH_CHARS = /[/\\?#]/;
var sanitizePathParam = function sanitizePathParam(value) {
  if (UNSAFE_PATH_CHARS.test(value)) return null;
  return value;
};
export var getGeoNexBaseUrl = function getGeoNexBaseUrl() {
  return process.env.NODE_ENV === 'development' ? '' : regionCheckEndpoint;
};
var FETCH_TIMEOUT_MS = 2000;
var createTimeoutSignal = function createTimeoutSignal() {
  if (typeof AbortSignal.timeout === 'function') {
    return AbortSignal.timeout(FETCH_TIMEOUT_MS);
  }
  var controller = new AbortController();
  setTimeout(function () {
    return controller.abort();
  }, FETCH_TIMEOUT_MS);
  return controller.signal;
};
var fetchFromGeonex = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, errorContext, options) {
    var baseUrl, timeoutSignal, signal, response, errorBody, message, isTimeout, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          baseUrl = getGeoNexBaseUrl();
          timeoutSignal = createTimeoutSignal();
          signal = options !== null && options !== void 0 && options.signal && typeof AbortSignal.any === 'function' ? AbortSignal.any([options.signal, timeoutSignal]) : timeoutSignal;
          _context.next = 1;
          return fetch("".concat(baseUrl).concat(path), _objectSpread(_objectSpread({}, options), {}, {
            signal: signal
          }));
        case 1:
          response = _context.sent;
          if (response.ok) {
            _context.next = 3;
            break;
          }
          _context.next = 2;
          return response.text();
        case 2:
          errorBody = _context.sent;
          throw new GeonexAPIError(response.status, response.statusText, errorBody, errorContext);
        case 3:
          return _context.abrupt("return", response.json());
        case 4:
          _context.prev = 4;
          _t = _context["catch"](0);
          if (!(_t instanceof GeonexAPIError)) {
            _context.next = 5;
            break;
          }
          throw _t;
        case 5:
          message = _t instanceof Error ? _t.message : String(_t);
          isTimeout = _t instanceof DOMException && _t.name === 'TimeoutError' || _t instanceof DOMException && _t.name === 'AbortError';
          throw new GeonexAPIError(isTimeout ? 408 : 0, isTimeout ? 'Request Timeout' : 'Network Error', message, errorContext);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 4]]);
  }));
  return function fetchFromGeonex(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
export var fetchBrandingFromGeonex = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(brandDomain) {
    var safeDomain;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (brandDomain) {
            _context2.next = 1;
            break;
          }
          return _context2.abrupt("return", null);
        case 1:
          safeDomain = sanitizePathParam(brandDomain);
          if (safeDomain) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return", null);
        case 2:
          return _context2.abrupt("return", fetchFromGeonex("/api/branding/".concat(safeDomain), 'branding'));
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function fetchBrandingFromGeonex(_x4) {
    return _ref3.apply(this, arguments);
  };
}();
export var fetchBrandingLogosFromGeonex = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(brandDomain) {
    var safeDomain;
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (brandDomain) {
            _context3.next = 1;
            break;
          }
          return _context3.abrupt("return", null);
        case 1:
          safeDomain = sanitizePathParam(brandDomain);
          if (safeDomain) {
            _context3.next = 2;
            break;
          }
          return _context3.abrupt("return", null);
        case 2:
          return _context3.abrupt("return", fetchFromGeonex("/api/branding/".concat(safeDomain, "/logo"), 'branding logo'));
        case 3:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function fetchBrandingLogosFromGeonex(_x5) {
    return _ref4.apply(this, arguments);
  };
}();
export var fetchRegionDataEndpoint = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(userName) {
    var safeUserName;
    return _regeneratorRuntime.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (userName) {
            _context4.next = 1;
            break;
          }
          return _context4.abrupt("return", null);
        case 1:
          safeUserName = sanitizePathParam(userName);
          if (safeUserName) {
            _context4.next = 2;
            break;
          }
          return _context4.abrupt("return", null);
        case 2:
          return _context4.abrupt("return", fetchFromGeonex("/api/region/lookup?username=".concat(encodeURIComponent(safeUserName)), 'region data'));
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function fetchRegionDataEndpoint(_x6) {
    return _ref5.apply(this, arguments);
  };
}();
export var fetchAllRegions = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    return _regeneratorRuntime.wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", fetchFromGeonex('/api/region', 'regions'));
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function fetchAllRegions() {
    return _ref6.apply(this, arguments);
  };
}();
export var fetchFeatureFlagsFromGeonex = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    return _regeneratorRuntime.wrap(function (_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          return _context6.abrupt("return", fetchFromGeonex('/api/feature-flags', 'feature flags'));
        case 1:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function fetchFeatureFlagsFromGeonex() {
    return _ref7.apply(this, arguments);
  };
}();
var LOGIN_NAMESPACE = 'login';
var REGION_SELECTOR = 'region_selector';

/**
 * Reads a flag out of the GET /api/feature-flags payload.
 *
 * Fail-closed: a missing namespace or a value that isn't literally `true`
 * reads as disabled, so an outage or a malformed payload degrades to the
 * feature being off rather than throwing on the boot path.
 */
var isGeonexFlagEnabled = function isGeonexFlagEnabled(response, namespace, flag) {
  var _response$flags;
  return (response === null || response === void 0 || (_response$flags = response.flags) === null || _response$flags === void 0 || (_response$flags = _response$flags[namespace]) === null || _response$flags === void 0 ? void 0 : _response$flags[flag]) === true;
};

/**
 * Whether Geonex says the region selector should be offered pre-login.
 */
export var isRegionSelectorEnabled = function isRegionSelectorEnabled(response) {
  return isGeonexFlagEnabled(response, LOGIN_NAMESPACE, REGION_SELECTOR);
};
export var fetchInitialSessionFromGeonex = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(version, includes) {
    return _regeneratorRuntime.wrap(function (_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          return _context7.abrupt("return", fetchFromGeonex("/api/session?version=".concat(version, "&includes=").concat(includes), 'session', {
            credentials: 'include'
          }));
        case 1:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function fetchInitialSessionFromGeonex(_x7, _x8) {
    return _ref8.apply(this, arguments);
  };
}();